import type {Signal} from '@bitstillery/mithril'
import {classes, unique_id} from '@bitstillery/common/lib/utils'
import {Icon} from '@bitstillery/common/components/ui/icon/icon'
import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'
import {failure_message} from '@bitstillery/common/lib/validation'
import type {Validator} from '@bitstillery/common/lib/validation'

export interface FieldSwitchAttrs {
    className?: string
    label?: string
    icon?: string
    model?: Signal<unknown> | undefined
    disabled?: boolean
    help?: string | undefined
    onchange?: () => void
    props?: {off: unknown; on: unknown}
    type?: 'default' | 'success'
    validation?: Validator
    variant?: 'default' | 'inline'
}

export class FieldSwitch extends MithrilComponent<FieldSwitchAttrs> {
    name = unique_id()
    props: {off: unknown; on: unknown} = {off: false, on: true}

    override oninit(vnode: m.Vnode<FieldSwitchAttrs>) {
        this.props = vnode.attrs.props ? vnode.attrs.props : {off: false, on: true}
    }

    view(vnode: m.Vnode<FieldSwitchAttrs>) {
        const validation = vnode.attrs.validation
        const invalid = validation ? validation._invalid : false
        const disabled = vnode.attrs.disabled
        return (
            <div
                className={classes(
                    'c-field-switch',
                    'field',
                    `type-${vnode.attrs.type ? vnode.attrs.type : 'default'}`,
                    `variant-${vnode.attrs.variant ? vnode.attrs.variant : 'default'}`,
                    vnode.attrs.className,
                    {
                        disabled: disabled,
                        invalid: validation && invalid && validation.dirty,
                        valid: !validation || !invalid,
                    },
                )}
            >
                {vnode.attrs.label && (
                    <label>
                        {vnode.attrs.label}
                        {vnode.attrs.icon && <Icon name={vnode.attrs.icon} />}
                        {validation && <span className='validation'>{validation.label}</span>}
                    </label>
                )}
                <div className='checkbox-row'>
                    <label className='switch' for={this.name}>
                        <input
                            checked={vnode.attrs.model?.value === this.props.on}
                            disabled={disabled || !vnode.attrs.model}
                            id={this.name}
                            name={this.name}
                            onchange={() => {
                                const model = vnode.attrs.model
                                if (!model) return
                                if (vnode.attrs.validation) {
                                    vnode.attrs.validation.dirty = true
                                }
                                model.value = model.value === this.props.on ? this.props.off : this.props.on
                                if (vnode.attrs.onchange) {
                                    vnode.attrs.onchange()
                                }
                            }}
                            type='checkbox'
                        />
                        <span class='slider' />
                    </label>
                </div>
                {(() => {
                    if (invalid && validation?.dirty) {
                        return <div className='help validation'>{failure_message(invalid)}</div>
                    } else if (vnode.attrs.help) {
                        return <div class='help'>{vnode.attrs.help}</div>
                    }
                    return undefined
                })()}
            </div>
        )
    }
}
